<div class="container nested">
  <div class="row">
    <div class="col-md-12">
      <p *ngIf="mainSponsors && mainSponsors.length === 0 && premiumSponsors && premiumSponsors.length === 0 && normalSponsors && normalSponsors.length === 0"
        class="no-infos-available">Keine Sponsoren eingetragen</p>
      <div class="section row">
        <h5 *ngIf="mainSponsors && mainSponsors.length > 0" class="col-md-12 mt-0">Hauptsponsoren</h5>
        <div class="col-md-4 sponsor-card__wrapper" *ngFor="let sponsor of mainSponsors">
          <app-team-league-sponsor-card [sponsor]="sponsor"></app-team-league-sponsor-card>
        </div>
      </div>
      <div class="section row">
        <h5 *ngIf="premiumSponsors && premiumSponsors.length > 0" class="col-md-12">
          Premiumsponsoren</h5>
        <div class="col-md-4 sponsor-card__wrapper" *ngFor="let sponsor of premiumSponsors">
          <app-team-league-sponsor-card [sponsor]="sponsor"></app-team-league-sponsor-card>
        </div>
      </div>
      <div class="section row">
        <h5 *ngIf="normalSponsors && normalSponsors.length > 0" class="col-md-12">Weitere
          Sponsoren</h5>
        <div class="col-md-4 sponsor-card__wrapper" *ngFor="let sponsor of normalSponsors">
          <app-team-league-sponsor-card  [sponsor]="sponsor"></app-team-league-sponsor-card>
        </div>
      </div>

    </div>
  </div>
</div>

